import React from 'react';
import { IAPIKey } from '../../api/llmapi';
import { Util } from '../../../fasades/util';
import { MdDeleteForever } from "react-icons/md";
import { MdOutlineAdd } from "react-icons/md";
import { IoClose } from "react-icons/io5";
import { RoundButton } from '../roundbutton';
import { IState } from '../../api/llmapi';
import { ApiKeyDialog } from '../../../dialogs/newapikey';
import { Users } from '../../../fasades/users';
import './chatlist.css';
import './apikeys.css';

interface ChatListProps {
    onExit : () => void;
    state  : IState;
}

export class APIKeys extends React.Component<ChatListProps> 
{
    async onDelete(apiKey : IAPIKey)
    {
        await Users.deleteAPIKey(apiKey.token);
        Users.getState();
    }

    async onNewChat()
    {
        try {
            ApiKeyDialog.showDialog();
        }
        catch(e) {
        }
    }

    async onExit()
    {
        this.props.onExit();
    }

    render() {
        const list = this.renderList();
        return (
            <div className="chats">
                <div className="chat-header">
                    <h1 className="chat-title">API Keys</h1>
                    <div className="chat-header-actions">
                        <RoundButton
                            description = { false }
                            icon = { MdOutlineAdd }
                            name = "New API Key"
                            onClick={ () => this.onNewChat() }/>
                        <RoundButton
                            description = { false }
                            icon = {IoClose}
                            name="Back to converstation"
                            onClick={ () => this.onExit() }/>
                    </div>
                </div>
                <ul className="chat-list">{list}</ul>
            </div>
        );
    }

    renderList() : React.JSX.Element[]
    {
        let list : React.JSX.Element[] = [];
        let i    = 0;

        if (this.props.state.user === undefined)
            return list;

        for (const apiKey of this.props.state.user.apiKeys) {
            list.push(
                <li key={apiKey.name + i}
                    className={`chat-entry`}>
                    <div >
                        <div className="apikey-header">{apiKey.name}</div>
                        <div className="apikeylist-time">
                            <span className="list-label">Created:</span>{Util.formatDate(new Date(apiKey.created)) }
                        </div>
                        <div className="apikeylist-time">
                            <span className="list-label">Token:</span>{ apiKey.token }
                        </div>
                        <div className="apikeylist-time"><span className="list-label">Last Used:</span>
                            { apiKey.lastUsed === undefined && "Never" }
                            { apiKey.lastUsed !== undefined && Util.formatDate(new Date(apiKey.lastUsed)) }
                        </div>
                    </div>
                    <div className="chat-actions">
                        <button title="Delete" onClick={(e) => {
                                e.stopPropagation();
                                this.onDelete(apiKey)
                            }}>
                            {React.createElement(MdDeleteForever as React.ComponentType)}
                        </button>
                    </div>
                </li>);
            i++;
        }

        return list;
    }
}

